<template>
  <div class="box6">
    <pageTitle title="课程与市场岗位高匹配&nbsp;&nbsp;助你脱颖而出" />
    <div class="content">
      <img class="top" src="../../../assets/coursePage/linux/box6/img01.png"/>
      <div class="bottom">
       
          <a>容器化运维<img class="top" src="../../../assets/coursePage/linux/box6/90.png"/></a>
       
        <ul>
          <li v-for="(item,index)  in arr" :key="index">{{item.h1}}</li>
        </ul>
      </div>
    </div>
   
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
  },
  data() {
    return {
     arr:[
      {
        "h1": "模块28：【实战】基于 Kubernetes 的黑马商城项目容器化运维实战之Docker容器化基础"
      },
      {
        "h1": "模块29：【实战】基于 Kubernetes 的容器化微服务架构与运维实战之Containerd容器部署"
      },
      {
        "h1": "模块30：【实战】基于 Kubernetes 的黑马商城项目容器化运维实战之Kubernetes容器编排入门"
      },
      {
        "h1": "模块31：【实战】基于 Kubernetes 的黑马商城项目容器化运维实战之Helm实现包管理与应用部署"
      },
      {
        "h1": "模块32：【实战】基于 Kubemetes 的黑马商城项目容器化运维实战之Java黑马商城项目容微服务部署实践"
      },
      {
        "h1": "模块33：【实战】基于 Kubemetes 的黑马商城项目容器化运维实战之Prometheus容器运维监控"
      },
      {
        "h1": "模块34：【实战】基于 Kubemetes 的黑马商城项目容器化运维实战之EFK日志管理解决方案"
      },
      {
        "h1": "模块35：【扩展】基于 Kubernetes 的黑马商城项目容器化运维实战之PaaS平台集成"
      },
      {
        "h1": "模块36：【小组实战】基于 Kubernetes 的黑马商城项目容器化运维实战之青橙电商项目实战"
      }
    ]
    };
  },
  computed: {
   
  },
};
</script>

<style lang="less" scoped>
.box6{
  background: url("../../../assets/coursePage/linux/box6/bg.png") no-repeat;
  background-size: 100% 100%;
  padding: 60px 30px 40px; 
  .content{
    .top{
      display: block;
      width: 610px;
      margin: 48px auto 0;
    }
    .bottom{
      background: linear-gradient( 159deg, #FFFFFF 0%, #FCFDFF 100%);
      border-radius: 20px;
      border: 1px solid #D2E3F6; 
      padding: 30px ;
      position: relative;
      top: -10px;
     
        a{
          display: block;
          height: 64px;
          background: linear-gradient( 333deg, #007DFF 0%, #48A2FF 100%);
          border-radius: 8px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 26px;
          color: #FFFFFF;
          line-height: 64px;
          text-align: center;
          font-style: normal;
          margin-bottom: 16px;
           position: relative;
            .top{
          width: 120px;
          position: absolute;
          right:-44px; 
          top: -102px; 
        }
        }
       
     
      ul{
        li{
          background: #F0F7FF;
          border-radius: 8px; 
          padding: 16px 20px 16px 24px;
          margin-bottom: 16px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 22px;
          color: #001F3E;
          line-height: 32px;
          text-align: left;
          font-style: normal;

        }
        li:last-child{
          margin-bottom: 0;
        }
      }
    }
  }

}
</style>
